import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '@ingka/text';
import classes from './ContractHoursRow.module.scss';

const EmptyHeaders = ({ showTitles = false }: { showTitles?: boolean }) => {
    const { t } = useTranslation();

    return (
        <>
            <th>
                <Text className={showTitles ? classes.details : ''} textStyle="Body.M">{showTitles ? t('BUSINESS_FUNCTION') : ''}</Text>
            </th>
            <th>
                <Text className={showTitles ? classes.details : ''} textStyle="Body.M">{showTitles ? t('COST_CENTRE') : ''}</Text>
            </th>
        </>
    );
};

export default EmptyHeaders;
